/* @ngInject */

export default (dateTimeService) => {
  /*
   * Constructor
   * --------------------------------------------------------------------------------
   */
  function Seat(
    id,
    accounts,
    brokers,
    partners,
    phones,
    webloanq,
    organization,
    subscription,
    timeStamp,
    expirationTimeStamp,
    isActive
  ) {
    this.id = id;
    this.accounts = accounts;
    this.brokers = brokers;
    this.partners = partners;
    this.phones = phones;
    this.webloanq = webloanq;
    this.organization = organization;
    this.subscription = subscription;
    this.timeStamp = timeStamp;
    this.expirationTimeStamp = expirationTimeStamp;
    this.isActive = isActive;
  }

  /*
   * Static Methods
   * --------------------------------------------------------------------------------
   */
  Seat.blank = function () {
    return Seat.build({
      id: '',
      accounts: 0,
      brokers: 0,
      partners: 0,
      phones: 0,
      webloanq: 0,
      organization: {},
      subscription: {},
      timeStamp: moment.utc().format('X'),
      expirationTimeStamp: moment.utc().add('61', 'days').endOf('day').format('X'),
      isActive: true
    });
  };
  Seat.build = function (data) {
    return new Seat(
      data.id,
      data.accounts,
      data.brokers,
      data.partners,
      data.phones,
      data.webloanq,
      data.organization,
      data.subscription,
      data.timeStamp ? data.timeStamp : moment.utc().format('X'),
      data.expirationTimeStamp
        ? data.expirationTimeStamp
        : moment.utc().add('61', 'days').endOf('day').format('X'),
      data.isActive
    );
  };

  Seat.prototype.getName = function () {
    return this.organization.name;
  };
  Seat.prototype.getPlanValue = function () {
    return this.subscription && this.subscription.plan && this.subscription.plan.value
      ? this.subscription.plan.value
      : 0;
  };
  Seat.prototype.getPlanInterval = function () {
    return this.subscription && this.subscription.plan && this.subscription.plan.interval
      ? this.subscription.plan.interval
      : '';
  };
  Seat.prototype.getBillable = function () {
    return this.accounts * this.getPlanValue();
  };
  Seat.prototype.getExpirationDate = function () {
    return dateTimeService.getFormattedDate(
      moment.utc().add('60', 'days').endOf('day').format('X')
    );
  };
  Seat.prototype.getDate = function () {
    return dateTimeService.getFormattedDate(this.timeStamp);
  };
  Seat.prototype.getTime = function () {
    return dateTimeService.getFormattedTime(this.timeStamp);
  };

  return Seat;
};
